import dataJson from './data.json';

export const data = dataJson;

export function formatCopyright(
  template: string,
  year: number,
  appName: string
): string {
  return template
    .replace('{year}', String(year))
    .replace('{appName}', appName);
}
